import { useCallback, useState } from 'react';
import { useOpenPlans } from '@/hooks/use-open-plans';
import QuotaUpsellDialog from '@/components/QuotaUpsellDialog';
import {
  classifyQuotaError,
  type QuotaLimitKind,
} from '@/lib/quota/classifyQuotaError';

interface Options {
  onBeforeUpgrade?: () => void;
}

export function useQuotaUpsellDialog({ onBeforeUpgrade }: Options = {}) {
  const [kind, setKind] = useState<QuotaLimitKind | null>(null);
  const openPlans = useOpenPlans();

  const openQuotaUpsell = useCallback((next: QuotaLimitKind) => {
    setKind(next);
  }, []);

  const handleQuotaError = useCallback((error: unknown): boolean => {
    const classified = classifyQuotaError(error);
    if (!classified) return false;
    setKind(classified);
    return true;
  }, []);

  const dialog = (
    <QuotaUpsellDialog
      kind={kind}
      open={kind !== null}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) setKind(null);
      }}
      onUpgrade={() => {
        onBeforeUpgrade?.();
        setKind(null);
        openPlans();
      }}
    />
  );

  return { dialog, openQuotaUpsell, handleQuotaError };
}
